export type UserModel = {
  id: number;
  salutation?: string;
  cooperationName?: string;
  firstname: string;
  lastname: string;
  email: string;
  avatar?: string; // base64
  avatarPath?: string;
  address?: {
    street?: string;
    houseNumber?: string;
    zipCode?: string;
    city?: string;
    country?: string;
  };
  phoneNumber?: string;
  birthdate?: Date;
  jobTitle?: string;
  roleId?: number;
  type?: UserType;
  description1?: string;
  description2?: string;
  description3?: string;
  fieldOfActivity?: string;
  trainings?: string[];
  careerSteps?: string[];
  publications?: PublicationModel[];
  engagements?: string[];
  contributions?: string[];
  bedMember?: boolean;
  bedMemberNumber?: string;
  newsletterSubscribed?: boolean;
};

export type RegisterUserModel = {
  firstname: string;
  lastname: string;
  email: string;
  password: string;
  newsletterOptIn?: boolean;
};

export type UpdateUserModel = {
  id: number;
  firstname: string;
  lastname: string;
  email: string;
  password: string;
};

export type LoginUserModel = {
  email: string;
  password: string;
};

export type PasswordResetModel = {
  token: string;
  password: string;
};

export type UserUpdateModel = {
  id: number;
  salutation?: string;
  firstName: string;
  lastName: string;
  email: string;
  bedMember: boolean;
  bedMemberNumber?: string;
  birthdate?: Date;
  jobTitle?: string;
  phoneNumber?: string;
  street?: string;
  houseNumber?: string;
  zipCode?: string;
  city?: string;
  country?: string;
  avatar?: File;
};

export type UserBackendModel = {
  id: number;
  salutation: string;
  cooperation_name: string;
  first_name: string;
  last_name: string;
  email: string;
  avatar_path?: string;
  bed_member: number;
  bed_member_nr?: string;
  birth_date: string;
  job_title: string;
  id_role: number;
  phone_number: string;
  street: string;
  street_nr: string;
  postal_code: string;
  city: string;
  country: string;
  type?: UserType;
  description1?: string;
  description2?: string;
  description3?: string;
  field_of_activity?: string;
  trainings?: string[];
  career_steps?: string[];
  publications?: PublicationModel[];
  engagements?: string[];
  contributions?: string[];
  newsletter_subscribed?: number;
};

export type UserBackendListModel = {
  id: number;
  cooperation_name?: string;
  first_name: string;
  last_name: string;
  email?: string;
  phone_number?: string;
  type?: UserType;
  job_title?: string;
  description1?: string;
  description2?: string;
  description3?: string;
  avatar_path?: string;
};

export type PublicationModel = {
  title: string;
  link?: string;
};

export enum UserType {
  USER = 'user',
  LECTURER = 'lecturer',
  COOPERATION = 'cooperation',
}

export type LecturerCreateModel = {
  firstname: string;
  lastname: string;
  email: string;
  phone_number: string;
  job_title: string;
  description1: string;
  description2: string;
  description3: string;
  field_of_activity: string;
  trainings: string[];
  career_steps: string[];
  publications: PublicationModel[];
  engagements: string[];
  contributions: string[];
  avatar?: File;
};

export type LecturerUpdateModel = {
  id: number;
  firstname: string;
  lastname: string;
  email: string;
  phone_number: string;
  job_title: string;
  description1: string;
  description2: string;
  description3: string;
  field_of_activity: string;
  trainings: string[];
  career_steps: string[];
  publications: PublicationModel[];
  engagements: string[];
  contributions: string[];
  avatar?: File;
};

export type InitialModel = {
  backgroundColor: string;
  color: string;
  text: string;
};
